import { defineComponent as _defineComponent } from 'vue'
import { beneficiaryTypeLabels, Trade, PaymentReport } from 'ah-api-gateways';
import { countryNameFromCC } from 'ah-common-lib/src/helpers/countries';
import { formatDate, SIMPLE_DATE_FORMAT } from 'ah-common-lib/src/helpers/time';
import { computed } from 'vue';
import WalletsFormattedCurrency from '../../currency/WalletsFormattedCurrency.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeTransactionInfo',
  props: {
    trade: null,
    payment: null
  },
  setup(__props: any) {

const props = __props as {
  trade: Trade;
  payment: PaymentReport;
};



const paymentDate = computed(() => props.payment.executionDate ?? props.trade.settlementDate!);

return { __sfc: true,props, paymentDate, beneficiaryTypeLabels, countryNameFromCC, formatDate, SIMPLE_DATE_FORMAT, WalletsFormattedCurrency }
}

})